export enum USER_TYPE {
	INDIVIDUAL_SHAREHOLDER = 'An Individual Shareholder',
	ACCREDITED_INVESTOR = 'An Accredited Investor',
	INSTITUTIONAL_FIRM = 'An Institutional Firm',
}
